/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringevents1Inputs */

const en_recurringevents1 = /** @type {(inputs: Recurringevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurring events`)
};

const de_recurringevents1 = /** @type {(inputs: Recurringevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederkehrende Events`)
};

/**
* | output |
* | --- |
* | "Recurring events" |
*
* @param {Recurringevents1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringevents1 = /** @type {((inputs?: Recurringevents1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringevents1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringevents1(inputs)
	return de_recurringevents1(inputs)
});
export { recurringevents1 as "recurringEvents" }